import { SyndeticsConfigHolder } from "@tlc/ls2pac/components/SyndeticsConfig";
import { TLCLogger } from "../../../../js/lib/logger";
import { PACStandardNumberUtil } from "../utils/PACStandardNumberUtil";

import { SyndeticsUnboundUtil } from "@tlc/syndetics-util";

export const LibraryThing = (function ($) {
  var enums = {
    enrichments: {
      summary: {
        name: "summary",
        className: "unbound_summary",
        label: SyndeticsUnboundUtil.EnrichmentLabel.get("summary"),
      },
      videoAndMusicSummary: {
        name: "audiovideo",
        className: "unbound_audiovideo",
        label: SyndeticsUnboundUtil.EnrichmentLabel.get("audiovideo"),
      },
      videoGameSummary: {
        name: "game",
        className: "unbound_game",
        label: SyndeticsUnboundUtil.EnrichmentLabel.get("game"),
      },
      aboutTheAuthor: {
        name: "author",
        className: "unbound_author",
        label: SyndeticsUnboundUtil.EnrichmentLabel.get("author"),
      },
      lookInside: {
        name: "lookinside",
        className: "unbound_lookinside",
        label: SyndeticsUnboundUtil.EnrichmentLabel.get("lookinside"),
      },
      series: {
        name: "series",
        className: "unbound_series",
        label: SyndeticsUnboundUtil.EnrichmentLabel.get("series"),
      },
      youMayAlsoLike: {
        name: "similar",
        className: "unbound_similar",
        label: SyndeticsUnboundUtil.EnrichmentLabel.get("similar"),
      },
      professionalReviews: {
        name: "reviews",
        className: "unbound_reviews",
        label: SyndeticsUnboundUtil.EnrichmentLabel.get("reviews"),
      },
      alsoAvailableAs: {
        name: "other",
        className: "unbound_other",
        label: SyndeticsUnboundUtil.EnrichmentLabel.get("other"),
      },
      tags: {
        name: "tags",
        className: "unbound_tags",
        label: SyndeticsUnboundUtil.EnrichmentLabel.get("tags"),
      },
      bookProfile: {
        name: "bookprofile",
        className: "unbound_bookprofile",
        label: SyndeticsUnboundUtil.EnrichmentLabel.get("bookprofile"),
      },
      awards: {
        name: "awards",
        className: "unbound_awards",
        label: SyndeticsUnboundUtil.EnrichmentLabel.get("awards"),
      },
      rclCoreTitles: {
        name: "rcl",
        className: "unbound_rcl",
        label: SyndeticsUnboundUtil.EnrichmentLabel.get("rcl"),
      },
      altmetricBadges: {
        name: "altmetrics",
        className: "unbound_altmetrics",
        label: SyndeticsUnboundUtil.EnrichmentLabel.get("altmetrics"),
      },
      alternateSeries: {
        name: "ltseries",
        className: "unbound_ltseries",
        label: SyndeticsUnboundUtil.EnrichmentLabel.get("ltseries"),
      },
      lists: {
        name: "lists",
        className: "unbound_lists",
        label: SyndeticsUnboundUtil.EnrichmentLabel.get("lists"),
      },
    },
    requestType: {
      bookJacketMedium: "BOOKJACKET-MD", // IMPORTANT: do not change without also changing sass/css classes
      bookJacketSmall: "BOOKJACKET-SM", // IMPORTANT: do not change without also changing sass/css classes
      bookJacketXSmall: "BOOKJACKET-XS", // IMPORTANT: do not change without also changing sass/css classes
      bookJacketLarge: "BOOKJACKET-LG", // IMPORTANT: do not change without also changing sass/css classes
    },
    idType: {
      isbn: "Isbn",
      upc: "Upc",
    },
  };
  // var syndeticsUnboundUtil = new SyndeticsUnboundUtil();
  var syndeticsUnboundUtil = null;
  var enrichmentsEnabled = null;
  var syndeticsConfigPromise = null;
  var syndeticsConfig = null;
  var languageData = null;
  var SU_TERMS_PATH =
    "https://www.proquest.com/about/terms-and-conditions.html";

  // var initScript = function (accountNumber, instanceId) {
  //   return syndeticsUnboundUtil
  //     .initScript(accountNumber, instanceId, 2) // 0 error (default), 1 warning, 2 info
  //     .then(function (enrichmentsOn) {
  //       return enrichmentsOn;
  //     })
  //     .catch(function (e) {
  //       TLCLogger.log(e);
  //       return [];
  //     });
  // };

  var isEnrichmentOn = function (enrichment) {
    var enrichmentsOn = syndeticsUnboundUtil.getEnrichmentsOn();

    if (!enrichmentsOn || enrichmentsOn.length === 0) {
      return false;
    }

    return enrichmentsOn.indexOf(enrichment.name) !== -1;
  };

  var addEnrichment = function (target, enrichment) {
    if (isEnrichmentOn(enrichment)) {
      target.append($('<div class="' + enrichment.className + '"></div>'));
    }
  };

  var getEnrichmentsOn = function () {
    var deferred = $.Deferred();
    SyndeticsConfigHolder.subscribe(({syndeticsConfig: sc, enrichmentsEnabled: eo, syndeticsUnboundUtil: util}) => {
      syndeticsUnboundUtil = util;
      enrichmentsEnabled = eo;
      syndeticsConfig = sc;
      return deferred.resolve(enrichmentsEnabled);
    });
    // $.when(getSyndeticsConfig()).then(function (syndeticsConfig) {
    //   if (syndeticsConfig.active === false) {
    //     return deferred.resolve([]);
    //   }

    //   return initScript(
    //     syndeticsConfig.accountNumber,
    //     syndeticsConfig.instanceId
    //   ).then(function (enrichmentsOn) {
    //     return deferred.resolve(enrichmentsOn);
    //   });
    // });
    return deferred.promise();
  };

  var refresh = function (selector, resource) {
    var refreshMetaDataPromise = $.Deferred();
    var isbn = PACStandardNumberUtil.getStandardNumbersByType(
      resource.standardNumbers,
      enums.idType.isbn
    );
    var upc = PACStandardNumberUtil.getStandardNumbersByType(
      resource.standardNumbers,
      enums.idType.upc
    );
    var metaData = {
      title: resource.shortTitle,
      author: resource.shortAuthor,
      isbn: isbn,
      upc: upc,
      usemegadiv: false,
      unbound_containing_selector: selector,
      branchFilters: resource.branchFilters,
    };

    syndeticsUnboundUtil
      .refreshMetaData(metaData)
      .then(function (response) {
        refreshMetaDataPromise.resolve(response.enrichmentsShown);
      })
      .catch(function (e) {
        refreshMetaDataPromise.reject(e);
      });

    return refreshMetaDataPromise.promise();
  };

  var getCoverSize = function (requestType) {
    var coverSize = "SM";

    if (requestType === enums.requestType.bookJacketMedium) {
      coverSize = "MD";
    }

    if (requestType === enums.requestType.bookJacketLarge) {
      coverSize = "LG";
    }
    return coverSize;
  };

  var getSyndeticsUrl = function (
    syndeticsConfig,
    requestType,
    standardNumbers,
    nicaptionParams
  ) {
    if (syndeticsConfig === null) {
      TLCLogger.error("Syndetics Config Not Found");
      return null;
    }

    if (syndeticsConfig.active === false) {
      TLCLogger.log("Syndetics disabled, aborting");
      return null;
    }

    if (
      syndeticsConfig.active === true &&
      (syndeticsConfig.clientCode == null ||
        syndeticsConfig.clientCode.length === 0)
    ) {
      TLCLogger.error("Syndetics enabled but client code not configured");
      return null;
    }

    var isbns = PACStandardNumberUtil.getStandardNumbersByType(
      standardNumbers,
      enums.idType.isbn
    );
    var upcs = PACStandardNumberUtil.getStandardNumbersByType(
      standardNumbers,
      enums.idType.upc
    );
    var coverSize = getCoverSize(requestType);
    var title = nicaptionParams[0];
    var contributor = nicaptionParams.length > 1 ? nicaptionParams[1] : null;

    return SyndeticsUnboundUtil.getCoverImage(
      syndeticsConfig.clientCode,
      isbns,
      title,
      coverSize,
      upcs,
      contributor
    );
  };

  var getSyndeticsConfig = function () {
    if (syndeticsConfig != null) {
      var deferred = $.Deferred();
      return deferred.resolve(syndeticsConfig);
    }

    if (syndeticsConfigPromise != null) {
      return syndeticsConfigPromise.promise();
    }

    syndeticsConfigPromise = $.Deferred();

    SyndeticsConfigHolder.subscribe(({syndeticsConfig: sc, enrichmentsEnabled: ee, syndeticsUnboundUtil: util}) => {
      TLCLogger.log("Syndetics config response", sc);
      syndeticsConfig = sc;
      enrichmentsEnabled = ee;
      syndeticsUnboundUtil = util;
      syndeticsConfigPromise.resolve(sc);
    })

    // $.get("syndetics-config", function (data) {
    //   TLCLogger.log("Syndetics config response", data);
    //   syndeticsConfig = data;
    //   syndeticsConfigPromise.resolve(data);
    // });

    return syndeticsConfigPromise.promise();
  };

  var hasLocalImage = function (resource, imageKey) {
    if (resource[imageKey] === undefined) {
      return false;
    }

    if (resource[imageKey] === null) {
      return false;
    }

    return resource[imageKey].length > 0;
  };

  var hasLocalSmallImage = function (resource) {
    if (!resource) {
      return false;
    }

    return hasLocalImage(resource, "localSmallImage");
  };

  var hasLocalLargeImage = function (resource) {
    if (!resource) {
      return false;
    }

    return hasLocalImage(resource, "localLargeImage");
  };

  var validateEnum = function (toCheck, against) {
    var myReturn = false;
    $.each(against, function (index, element) {
      if (toCheck.toLowerCase() === element.toLowerCase()) {
        myReturn = true;
      }
    });
    return myReturn;
  };

  var hasEnrichmentContainer = function (enrichments) {
    if (syndeticsConfig.active === false) {
      return false;
    }

    var enrichmentsOn = syndeticsUnboundUtil.getEnrichmentsOn();

    for (var i = 0, len = enrichments.length; i < len; i++) {
      if (enrichmentsOn.indexOf(enrichments[i].name) !== -1) {
        return true;
      }
    }

    return false;
  };

  return {
    hasRelatedTab: function () {
      var relatedEnrichments = [
        enums.enrichments.alternateSeries,
        enums.enrichments.altmetricBadges,
        enums.enrichments.rclCoreTitles,
        enums.enrichments.tags,
        enums.enrichments.youMayAlsoLike,
        enums.enrichments.lists,
        enums.enrichments.alsoAvailableAs,
        enums.enrichments.series,
      ];
      return hasEnrichmentContainer(relatedEnrichments);
    },
    hasMoreInfoTab: function () {
      var moreInfoEnrichments = [
        LibraryThing.enums.enrichments.summary,
        LibraryThing.enums.enrichments.videoGameSummary,
        LibraryThing.enums.enrichments.videoAndMusicSummary,
        LibraryThing.enums.enrichments.awards,
        LibraryThing.enums.enrichments.lookInside,
        LibraryThing.enums.enrichments.bookProfile,
        LibraryThing.enums.enrichments.aboutTheAuthor,
      ];
      return hasEnrichmentContainer(moreInfoEnrichments);
    },
    hasEditorialReviews: function () {
      return hasEnrichmentContainer([
        LibraryThing.enums.enrichments.professionalReviews,
      ]);
    },
    hasSummary: function () {
      return hasEnrichmentContainer([LibraryThing.enums.enrichments.summary]);
    },
    initConfig: function (language, callback) {
      languageData = language;
      $.when(getEnrichmentsOn()).then(function (enrichmentsOn) {
        TLCLogger.log(
          "initial request of syndeticsConfig, enrichmentsOn:",
          enrichmentsOn
        );
        callback(enrichmentsOn);
      });
    },
    getConfig: function () {
      return getSyndeticsConfig();
    },
    enums: enums,
    addTOSLink: function (target) {
      if (syndeticsConfig === null || syndeticsConfig.active === false) {
        return;
      }
      target.addClass("has-syndetics");
      if (target.find(".tos-link").length === 0) {
        target.append(
          '<a href="' +
            SU_TERMS_PATH +
            '" class="tos-link" target="_blank">Syndetics Terms and Conditions</a>'
        );
      }
    },
    getSeriesLogo: function (requestType, standardNumbers, seriesName) {
      if (validateEnum(requestType, enums.requestType) === false) {
        throw "Invalid request type: " + requestType;
      }

      if (standardNumbers) {
        return getSyndeticsUrl(syndeticsConfig, requestType, standardNumbers, [
          seriesName,
        ]);
      }

      return null; // TODO could I just return dummy here?
    },
    getBookjacketUrl: function (requestType, resource) {
      if (!resource) {
        return null;
      }

      if (validateEnum(requestType, enums.requestType) === false) {
        throw "Invalid request type: " + requestType;
      }

      if (
        (requestType === enums.requestType.bookJacketSmall ||
          requestType === enums.requestType.bookJacketMedium) &&
        hasLocalSmallImage(resource)
      ) {
        return resource.localSmallImage;
      }

      if (
        requestType === enums.requestType.bookJacketLarge &&
        hasLocalLargeImage(resource)
      ) {
        return resource.localLargeImage;
      }

      var dummyContent = [resource.shortTitle];
      if (resource.shortAuthor) {
        dummyContent.push(resource.shortAuthor);
      }
      return getSyndeticsUrl(
        syndeticsConfig,
        requestType,
        resource.standardNumbers,
        dummyContent
      );
    },
    refreshMetaData: function (selector, metaData, retryCallback) {
      var deferred = $.Deferred();
      $.when(getSyndeticsConfig()).then(function (syndeticsConfig) {
        var target = $(selector);

        LibraryThing.removeUnableToLoadContent(target);
        LibraryThing.removeNoContentFound(target);
        metaData.branchFilters = syndeticsConfig.branchFilters;
        $.when(refresh(selector, metaData))
          .done(function (enrichmentsShown) {
            if (enrichmentsShown.length === 0) {
              LibraryThing.showNoContentFound(target);
            }
            deferred.resolve(enrichmentsShown);
          })
          .fail(function (reason) {
            LibraryThing.showUnableToLoadContent(target, retryCallback);
            TLCLogger.warn(reason);
            deferred.reject();
          });
      });
      return deferred.promise();
    },
    addEnrichment: function (target, enrichment) {
      addEnrichment(target, enrichment);
    },
    showNoContentFound: function (target) {
      var noConentEl = $(target).find(".no-content");
      if (noConentEl.length === 0) {
        $(target).append(
          '<p class="no-content">' + languageData.noContent + "</p>"
        );
        return;
      }
      noConentEl.show();
    },
    removeNoContentFound: function (target) {
      var noConentEl = $(target).find(".no-content");
      if (noConentEl.length === 0) {
        return;
      }
      noConentEl.remove();
    },
    showUnableToLoadContent: function (target, retryCallback) {
      var loadingErrorEl = $(target).find(".loading-error");
      $(target).on("click", ".loading-error .refresh-su", retryCallback);
      if (loadingErrorEl.length === 0) {
        var html = '<p class="loading-error">';
        html += languageData.unableToLoad;
        html += " ";
        html += `<button class="refresh-su TEMP_muiButtonAsLink">`;
        html += languageData.tryAgain;
        html += "</button>";
        html += "</p>";
        $(target).append(html);
        return;
      }
      loadingErrorEl.show();
    },
    removeUnableToLoadContent: function (target) {
      var loadingErrorEl = $(target).find(".loading-error");
      $(target).off("click", ".loading-error .refresh-su");
      if (loadingErrorEl.length === 0) {
        return;
      }
      loadingErrorEl.remove();
    },
  };
})(jQuery);
